import React from "react";

const SwitchCompact = ({ controlId, isOn, handleToggle, disabled }) => {
	const checked = Boolean(isOn);

	return (
		<div className={`switch-compact ${disabled ? "disabled" : ""}`}>
			<input
				checked={checked}
				onChange={handleToggle}
				className="switch-compact__checkbox"
				id={controlId}
				type="checkbox"
				disabled={disabled}
			/>
			<label
				style={{ background: checked ? "var(--primary, #5b49fe)" : undefined }}
				className="switch-compact__label"
				htmlFor={controlId}
			>
				<span className="switch-compact__button" />
			</label>
		</div>
	);
};

export default SwitchCompact;
